import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion, useScroll } from "framer-motion";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Intro from "@/components/Intro";
import StatsBand from "@/components/StatsBand";
import Ecosystem from "@/components/Ecosystem";
import HowWeWork from "@/components/HowWeWork";
import WhySmipl from "@/components/WhySmipl";
import Industries from "@/components/Industries";
import Customers from "@/components/Customers";
import Partners from "@/components/Partners";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import ContactModal from "@/components/ContactModal";
import GroupPage from "@/pages/GroupPage";
import ItemPage from "@/pages/ItemPage";
import ProductsPage from "@/pages/ProductsPage";
import ContactPage from "@/pages/ContactPage";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = ({ openContact }) => (
  <main>
    <Hero openContact={openContact} />
    <Intro />
    <StatsBand />
    <Ecosystem openContact={openContact} />
    <HowWeWork />
    <WhySmipl />
    <Industries />
    <Customers />
    <Partners />
    <FinalCta openContact={openContact} />
  </main>
);

function App() {
  const [contact, setContact] = useState(false);
  const { scrollYProgress } = useScroll();
  const openContact = useCallback(() => setContact(true), []);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollManager />
        <motion.div
          data-testid="scroll-progress"
          style={{ scaleX: scrollYProgress }}
          className="fixed top-0 left-0 right-0 h-[2px] bg-smipl-orange z-[110] origin-left"
        />
        <Navbar openContact={openContact} />
        <Routes>
          <Route path="/" element={<Home openContact={openContact} />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/:group" element={<GroupPage openContact={openContact} />} />
          <Route path="/:group/:id" element={<ItemPage openContact={openContact} />} />
        </Routes>
        <Footer />
        <ContactModal open={contact} onClose={() => setContact(false)} />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
